<template>
  <label
    :for="item"
    class="filter-item"
  >
    <input
      :id="item"
      :filter-type="category"
      class="filter-item__checkbox"
      type="checkbox"
      :checked="getSelectedFilters.includes(item) ? 'checked' : ''"
      :name="inputName"
      @change="selectFilter"
    >
    <span
      class="filter-item__custom-checkbox"
    />
    <span class="filter-item__text">
      {{ item }}
      <FilterMatches
        :filter="item"
      />
    </span>
  </label>
</template>

<script>
import FilterMatches from '@/components/subcomponents/filters/FilterMatches.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterItem',
  components: {
    FilterMatches
  },
  props: {
    item: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    inputName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checked: false
    }
  },
  computed: {
    ...mapGetters({
      uncheckAll: 'filters/getUncheckFilters'
    }),
    getSelectedFilters () {
      const locations = this.$store.getters['filters/getSelectedLocations']
      const departments = this.$store.getters['filters/getSelectedDepartments']
      const team = this.$store.getters['filters/getSelectedTeams']

      return locations.concat(departments.concat(team))
    }
  },
  methods: {
    toggleCheck (e) {
      this.checked = e.target.checked
    },
    selectFilter (e) {
      this.toggleCheck(e)

      const filter = {
        value: e.target.id,
        checked: e.target.checked,
        category: this.category
      }

      this.$emit('input', filter)
    }
  }
}
</script>

<style scoped lang="scss">
@use 'variables';

.filter-item {
  display: flex;
  align-items: center;
  position: relative;
  color: variables.$color-white;
  margin: 0.4rem 0 0.4rem 0.25rem;

  &__checkbox {
    position: absolute;
    top: 0;
    left: 0;
    height: 17px;
    width: 100%;
    opacity: 0;
    cursor: pointer;
    transition: 200ms ease all;

    &:checked ~ .filter-item__custom-checkbox::after {
      width: 9px;
      height: 9px;
      margin: 0;
    }
  }

  &__custom-checkbox {
    display: inline-block;
    width: 17px;
    height: 17px;
    flex: 0 0 17px;
    position: relative;
    border-radius: 4px;
    border: 2px solid variables.$color-gray-3;
    background: none;
    pointer-events: none;
    box-sizing: border-box;
    transition: 200ms ease all;

    &::after {
      content: '';
      left: 2px;
      top: 2px;
      position: absolute;
      height: 0;
      width: 0;
      border-radius: 2px;
      background-color: variables.$color-brand;
      transition: 200ms ease all;
      margin: 4px;
    }
  }

  &__text {
    padding-left: 0.5rem;
    color: variables.$color-gray-3;
    line-height: 1.4;
    font-size: 1em;
  }
}
</style>
